export default __webpack_public_path__ + "static/media/update-icon.9b8266f86527f717c2f13db8ac0f4530.svg";